import { StaticImageData } from "next/image";
import { PublicSettings } from "@/src/config/PublicSettings";

export type ISubMenu = {
    title: string;
    text: string;
    url: string;
    icon?: StaticImageData;
    target?: string;
    rel?: string;
    submenu?: ISubMenu[];
};

export const footerCompanySubmenus: ISubMenu[] = [
    {
        title: "About Us",
        text: "",
        url: "/about-us"
    },
    {
        title: "Careers",
        text: "",
        url: "https://www.linkedin.com/jobs/search?keywords=&location=United%20States&locationId=&geoId=103644278&f_TPR=&f_C=40836348&position=1&pageNum=0"
    },
    {
        title: "Contact Us",
        text: "",
        url: "/contact"
    }
];
export const footerPetInsuranceSubmenus: ISubMenu[] = [
    {
        title: "Dog Insurance",
        text: "",
        url: "/dog-insurance"
    },
    {
        title: "Puppy Insurance",
        text: "",
        url: "/puppy-insurance"
    },
    {
        title: "Cat Insurance",
        text: "",
        url: "/cat-insurance"
    },
    {
        title: "Kitten Insurance",
        text: "",
        url: "/kitten-insurance"
    },
    {
        title: "Coverage Info",
        text: "",
        url: "/what-does-pet-insurance-cover"
    },
    {
        title: "Sample Policy",
        text: "",
        url: "/sample-policy"
    },
    {
        title: "FAQS",
        text: "",
        url: "/faqs"
    },
    {
        title: "Cat & Dog Breeds",
        text: "",
        url: "/breeds"
    },
    {
        title: "Locations",
        text: "",
        url: "/locations"
    },
    {
        title: "Spot Perks",
        text: "",
        url: "/spot-perks"
    }
];
export const footerResourcesSubmenus: ISubMenu[] = [
    {
        title: "Blog",
        text: "",
        url: "/blog"
    },
    {
        title: "Employers",
        text: "",
        url: "/employers"
    },
    {
        title: "Member Center",
        text: "",
        url: PublicSettings.MEMBER_CENTER_URL_ROOT,
        target: "_self"
    },
    {
        title: "ADA Notice",
        text: "",
        url: "/ada-compliance-notice"
    },
    {
        title: "Complaints",
        text: "",
        url: "complaints-process"
    }
];
export const adviceSubmenus: ISubMenu[] = [
    {
        title: "Blog",
        text: "Learn more about how to take care of your pet, from feeding to training, at every life stage.",
        url: "/blog",
        icon: require("@/src/media/icons/menu/computer.svg")
    },
    {
        title: "Breeds",
        text: "Discover the personality and characteristics of your favorite cat or dog breeds.",
        url: "/breeds",
        icon: require("@/src/media/icons/menu/dog-blue-red.svg")
    },
    {
        title: "Pet Insurance by Province",
        text: "Find province-specific information about Pet Insurance in Canada.",
        url: "/locations",
        icon: require("@/src/media/icons/menu/Illustrated-Locations.svg")
    },
    {
        title: "News",
        text: "Learn about exciting news and trends here",
        url: "/news",
        icon: require("@/src/media/icons/menu/News-Icon.svg")
    }
];
export const compareSubmenus: ISubMenu[] = [
    {
        title: "Pet Insurance Providers",
        text: "See how Spot measures up against other pet insurances when it comes to coverage.",
        url: "/compare-pet-insurance",
        icon: require("@/src/media/icons/menu/paw.svg")
    },
    {
        title: "Pet Insurance Plans",
        text: "Find out what eligible conditions and accidents our plans cover.",
        url: "/what-does-pet-insurance-cover",
        icon: require("@/src/media/icons/menu/hand-heart.svg")
    }
];
export const petSubmenus: ISubMenu[] = [
    {
        title: "Dog Insurance",
        text: "Pet insurance for dogs to protect your wallet and your best friend.",
        url: "/dog-insurance",
        icon: require("@/src/media/icons/color/Dog-Heart.svg")
    },
    {
        title: "Puppy Insurance",
        text: "Pet insurance for puppies as young as 8 weeks.",
        url: "/puppy-insurance",
        icon: require("@/src/media/icons/color/dog-blue.svg")
    },
    {
        title: "Cat Insurance",
        text: "Affordable cat insurance to keep your feline friend healthy and happy.",
        url: "/cat-insurance",
        icon: require("@/src/media/icons/color/heart-cat.svg")
    },
    {
        title: "Kitten Insurance",
        text: "Pet insurance for kittens as young as 8 weeks.",
        url: "/kitten-insurance",
        icon: require("@/src/media/icons/color/cat-blue.svg")
    },
    {
        title: "FAQs",
        text: "Frequently Asked Questions.",
        url: "/faqs",
        icon: require("@/src/media/icons/menu/question-mark.svg")
    }
];

export const ctaMapping = {
    // Special case for cart with id
    idMappings: {
        "cart-quote": "Cart CTA"
    },

    // URL path based mappings
    pathMappings: {
        "/quote": "Quote CTA",
        "quote.spotpetinsurance.ca": "Quote CTA",
        "/employers": "Employers CTA",
        "/faqs": "FAQs CTA",
        "/spot-perks": "Perks CTA",
        "/what-does-pet-insurance-cover": "Coverage CTA",
        "/compare-pet-insurance": "Compare CTA",
        "/dog-insurance": "Dog CTA",
        "/cat-insurance": "Cat CTA",
        "/puppy-insurance": "Puppy CTA",
        "/kitten-insurance": "Kitten CTA",
        "/sample-policy": "Sample Policy CTA"
    },

    // URL pattern based mappings (only for special cases like phone numbers)
    patternMappings: [{ pattern: /^tel:/, name: "Call Us CTA" }]
};
